
var suggestions = angular.module('suggestions', ['classy', 'suggestedAppealQuestions', 'suggestedPolicies', 'suggestedSsqs']);
suggestions.classy.controller({
    name: 'ResourceSuggestionsController',
    inject: ['$scope', 'authServiceFactory'],
    init: function()
    {
    }
});

stateProviders.push({
    name: 'schoolside.resources.suggestions',
    abstract: true,
    url: '/suggestions',
    templateUrl: 'fast/submodules/schoolside/resources/suggestions/suggestions.html?v=' + versionNo,
    controller: 'ResourceInformationController'
});

